import actionTypes from "../actionTypes";
import {IMapas, IParcela} from "../../types";
import {LatLngTuple} from "leaflet";

const update = require('immutability-helper');


export const initialState = {
    mapa: 'satelite' as IMapas,
    parcelas: [] as IParcela[],
    usuarios: [] as string[],
    zoom: 7 as number,
    center: [40, -3.7] as LatLngTuple,
    usuario: '',
    estaciones: [] as Record<string, any>[],
    sensores: [] as Record<string, any>[],
    cotas_sensores: {
        1: ["cota_inf", "cota_sup"],
        2: ["cota_inf", "cota_sup"],
        3: ["cota_inf", "cota_sup"],
        4: ["cota_inf", "cota_sup"],
        5: ["cota_inf", "cota_sup"],
        6: ["cota_inf", "cota_sup"],
        7: ["cota_inf", "cota_sup"],
        8: ["cota_inf", "cota_sup"],
        11: ["cota_inf", "cota_sup"]
    }

};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'set-principal-mapa':
            return update(state, {mapa: {$set: action.mapa}});

        case 'set-principal-parcelas':
            return update(state, {parcelas: {$set: action.parcelas}});

        case 'set-principal-usuarios':
            return update(state, {usuarios: {$set: action.usuarios}});

        case 'set-principal-zoom':
            return update(state, {zoom: {$set: action.zoom}});

        case 'set-principal-center':
            return update(state, {center: {$set: action.center}});

        case 'set-principal-usuario':
            return update(state, {usuario: {$set: action.usuario}});

        case 'set-principal-estaciones':
            return update(state, {estaciones: {$set: action.estaciones}});

        case 'set-principal-sensores':
            return update(state, {sensores: {$set: action.sensores}});

        default:
            return state
    }
}